import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { AddEditReminderModelComponent } from './add-edit-reminder-model/add-edit-reminder-model.component';
import { ToastrService } from 'ngx-toastr';
import { ChecklistTaskService } from '@app/shared/services/checklist/checklist-task.service';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { ChecklistService } from '@app/shared/services/checklist/checklist.service';
import { ChecklistTaskComponent } from '@app/shared/component/checklist-task/checklist-task.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'reminder-v2',
  templateUrl: './reminder-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReminderV2Component implements OnInit, OnDestroy {
  setZeroMargin = false;
  triggerTypeList;
  @Output() reminderStatusUpdateEvent = new EventEmitter();

  @Input() hideManageButton = false;
  @Input() data: any;
  @Input() fId: any;
  @Input() formsList: any;
  @Input() currentuserId;
  @Input() currentFormId;
  @Input() formValue;
  @Input() userId;
  @Input() templateData: any;
  @Input() isRemoveEditSaveSharing = false;
  reminder_list = [];
  suggestion_reminder_count = [];
  is_loading = true;
  form_id;
  currentForm;
  resolve_id;
  reminder_configurations_list = [];
  subscription = new Subscription();
  linkedTasks = [];

  constructor(
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private _documentService: DocumentService,
    private checklistTaskService: ChecklistTaskService,
    private checklistService: ChecklistService
  ) {}

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.form_id = this.data?.fid ? this.data.fid : this.data.form_id ? this.data.form_id : this.data.vault_form_id;
    this.currentForm = this.formsList.find((x) => x.id == this.form_id);
    this.triggerTypeList = this.currentForm.template[0].singleFieldForm.filter((x) => x.triggerType);
    this.reminder_configurations_list = this.currentForm.reminder_configurations
      .split(',')
      .filter((config) => config.trim() !== '' && config !== undefined && config !== null);
    this.getReminderListForCurrentForms();
    this.getChecklistTasksLinkedWithForms();
  }

  getReminderListForCurrentForms() {
    this.subscription.add(
      this.documentService.getReminderList(this.userId ? this.userId : this.currentuserId, this.currentFormId).subscribe(
        (res) => {
          this.resolve_id = null;
          this.is_loading = false;
          this.reminder_list = res;
          this.suggestion_reminder_count = [];
          this.reminder_configurations_list.forEach((element) => {
            if (this.reminder_list.findIndex((x) => x.suggestion_type == element?.trim()?.toLowerCase()) == -1) {
              this.suggestion_reminder_count.push(element);
            }
          });
          this.cd.detectChanges();
        },
        (error) => {}
      )
    );
  }
  callAction(items) {
    this.resolve_id = items.id;
    this.subscription.add(
      this.documentService
        .updateReminder({
          id: items.id,
          status: 'complete',
        })
        .subscribe(
          (res) => {
            this.toastr.success('Reminder Updated  successfully.');
            this.getReminderListForCurrentForms();
          },
          (error) => {
            this.toastr.error(error);
          }
        )
    );
  }

  createReminder() {
    const dialogRef = this.dialog.open(AddEditReminderModelComponent, {
      data: {
        currentFormId: this.currentFormId,
        userId: this.userId ? this.userId : this.currentuserId,
        form_id: this.form_id,
        formValue: this.formValue,
        reminder_configurations_list: this.reminder_configurations_list,
        triggerTypeList: this.triggerTypeList,
        templateData: this.templateData,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        this.reminderStatusUpdateEvent.emit();
        this.getReminderListForCurrentForms();
        this.getChecklistTasksLinkedWithForms();
        this.cd.detectChanges();
      })
    );
  }
  getChecklistTasksLinkedWithForms() {
    this.subscription.add(
      this.checklistTaskService.getChecklistTasksLinkedWithForms(this.userId, this.currentFormId).subscribe((res) => {
        this.linkedTasks = res;

        // this.taskUpdateEvent.next(this.linkedTasks);
        this.cd.detectChanges();
      })
    );
  }
  editTask(task) {
    if (this.isRemoveEditSaveSharing) {
      return;
    }
    const dialogRef = this.dialog.open(ChecklistTaskComponent, {
      height: '100%',
      panelClass: 'full-window-dialog',
      data: {
        taskId: task.id,
        mode: 'edit',
        isCustom: false,
        groupName: '',
        manageTask: true,
      },
      disableClose: false,
      autoFocus: false,
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe(() => {
        this.getChecklistTasksLinkedWithForms();
        this.cd.detectChanges();
      })
    );
  }
}
